<mat-card class="attached-entity-card">
	<mat-card-content class="card-content">
		<mat-checkbox
			[checked]="selectedEntityPks()?.includes(entity().data.pk)"
			(change)="isSelected.emit([$event.checked, entity().data])"
			class="card-checkbox"
		/>
		<div class="content-info">
			<mat-card-title class="card-title">
				{{ entity().data?.name }}
			</mat-card-title>
			<mat-card-subtitle class="card-subtitle">
				{{ entity().data?.status }}
			</mat-card-subtitle>
		</div>
	</mat-card-content>

	<div class="card-img">
		<mat-icon [svgIcon]="entity().type"></mat-icon>
	</div>
</mat-card>
